import { Area, AreaContent } from "../../useAreas/areas/types";
import hero from "../../../../assets/image/areas/hero/erbrecht.webp";

const data: AreaContent = {
  id: Area.ERBRECHT,
  hero: hero,
  content: [
    "Im Erbrecht beraten und vertreten wir Sie in allen Fragen rund um den Nachlass, seine Regelung und Verwaltung. Wir begleiten Sie insbesondere bei der Testamentsgestaltung, der vorweggenommenen Erbfolge sowie bei Schenkungen zu Lebzeiten unter Berücksichtigung rechtlicher und steuerlicher Aspekte.",
    "Unsere Leistungen im Erbrecht umfassen unter anderem:",
    [
      "Testamentsgestaltung, insbesondere Erbfolge, Berliner Testament, Pflichtteilsansprüche und Vermächtnisse",
      "Beratung im Erbfall, insbesondere zur Annahme oder Ausschlagung der Erbschaft",
      "Durchsetzung von Auskunftsansprüchen",
      "Testamentsvollstreckung und Nachlassverwaltung",
      "Erstellung von Patientenverfügungen",
      "Erstellung von Vorsorgevollmachten",
    ],
  ],
  bullets: [
    "Testamentsgestaltung",
    "Erbfolge",
    "Berliner Testament",
    "Pflichtteilsansprüche",
    "Vermächtnisse",
    "Annahme oder Ausschlagung der Erbschaft",
    "Auskunftsansprüche",
    "Testamentsvollstreckung",
    "Nachlassverwaltung",
    "Patientenverfügungen",
    "Vorsorgevollmachten",
  ],
  more: [],
};

export default data;
